enum Routes {
  Home = '/',
  Projects = '/projects',
  Impact = '/impact',
  Stories = '/impact/related',
  Supporters = '/supporters',
  Profile = '/profile',
  Membership = '/membership',
  MembershipEmotional = '/membership/v2',
  MembershipPayment = '/membership/payment',
  MembershipCheckout = '/membership/checkout',
  Terms = '/terms',
  TermsB2B = '/terms/b2b',
  TermsB2C = '/terms/b2c',
  TermsPartner = '/terms/partners',
  Cookies = '/cookies',
  CheckoutSuccess = '/successful-checkout',
  CheckoutFailure = '/failed-checkout',
  Privacy = '/privacy',
  ContributePayment = '/checkout/:projectCode/payment',
  ContributeLanding = '/checkout/:projectCode',
  Business = '/business',
  Connect = '/connect',
  CleanStreamFriday = '/clean-stream-friday',
  NotFound = '/*',
}

const baseRouteConfig = [
  { path: Routes.Home, component: import('./pages/Home/Home') },
  { path: Routes.Projects, component: import('./pages/Projects') },
  { path: Routes.Impact, component: import('./pages/Impact') },
  { path: Routes.Supporters, component: import('./pages/Supporters') },
  {
    path: `${Routes.Supporters}/:profileNumber`,
    component: import('./pages/Profile'),
  },
  {
    path: `${Routes.Impact}/:storyId/updates/:newsSlug`,
    component: import('./pages/Update'),
  },
  { path: `${Routes.Impact}/:newsSlug`, component: import('./pages/Update') },
  { path: `${Routes.Stories}/:storySlug`, component: import('./pages/Story') },
  {
    path: `${Routes.Projects}/:projectCode`,
    component: import('./pages/Project'),
  },
  {
    path: `${Routes.Projects}/:projectCode/:projectSlug`,
    component: import('./pages/Project'),
  },
  { path: Routes.Profile, component: import('./pages/Profile') },
  {
    path: Routes.MembershipPayment,
    component: import('./pages/MembershipPayment'),
  },
  {
    path: Routes.MembershipCheckout,
    component: import('./pages/MembershipLanding'),
  },
  { path: Routes.Membership, component: import('./pages/Membership') },
  {
    path: Routes.MembershipEmotional,
    component: import('./pages/MembershipEmotional'),
  },
  {
    path: Routes.ContributePayment,
    component: import('./pages/ContributePayment'),
  },
  {
    path: Routes.ContributeLanding,
    component: import('./pages/ContributeLanding'),
  },
  {
    path: Routes.CheckoutSuccess,
    component: import('./pages/CheckoutSuccess'),
  },
  {
    path: Routes.CheckoutFailure,
    component: import('./pages/CheckoutFailure'),
  },
  { path: Routes.Terms, component: import('./pages/Terms') },
  { path: Routes.TermsB2B, component: import('./pages/Terms/B2B') },
  { path: Routes.TermsB2C, component: import('./pages/Terms/B2C') },
  { path: Routes.TermsPartner, component: import('./pages/Terms/Partners') },
  { path: Routes.Cookies, component: import('./pages/Cookies') },
  { path: Routes.Privacy, component: import('./pages/Privacy') },
  { path: Routes.Business, component: import('./pages/Business') },
  { path: Routes.Connect, component: import('./pages/Connect') },
  {
    path: Routes.CleanStreamFriday,
    component: import('./pages/CleanStreamFriday'),
  },
];

function createRoutesForLocale(locale: string) {
  return baseRouteConfig.map(({ path, component }) => {
    const prefixedPath = path === '/' ? `/${locale}` : `/${locale}${path}`;
    return {
      key: path === Routes.Home ? `${locale}-home` : `${locale}-${path}`,
      path: prefixedPath,
      component,
    };
  });
}

function getRouteConfig(locales: string[]) {
  const defaultRoutes = baseRouteConfig.map(({ path, component }) => ({
    key: path,
    path,
    component,
  }));

  const i18nRoutes = locales.flatMap(createRoutesForLocale);

  return [
    ...defaultRoutes,
    ...i18nRoutes,
    // Catch-all routes must be the last to act as fallbacks
    {
      key: Routes.NotFound,
      path: Routes.NotFound,
      component: import('./pages/NotFound'),
    },
  ];
}

export { Routes, getRouteConfig };
